export const SET_CONNECTORS = 'SET_CONNECTORS';
export const SET_CONNECTORS_CONNECTION_STATUS = 'SET_CONNECTORS_CONNECTION_STATUS';
